import { Box, Button, Card, CardContent, CardHeader, makeStyles, Typography } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

import { updateFriendsOfSkiptownSection } from '../../../actions/facilities/facilities.actions'
import StyledSwitch from '../../Common/StyledSwitch'
import StyledTextField from '../../Common/StyledTextField'

const TITLE_FALLBACK = 'Friends of Skiptown'
const SUBTITLE_FALLBACK = 'Exclusive offers from trusted Skiptown partners.'

const useStyles = makeStyles(() => ({
	root: { width: '100%', marginBottom: '1.5rem' },
	header: { fontSize: '1rem' },
	showToggle: { display: 'flex', alignItems: 'center', gap: '0.5rem' },
	fields: {
		display: 'flex',
		flexDirection: 'row',
		flexWrap: 'wrap',
		gap: '1.5rem',
		marginBottom: '1.5rem',
		// Full-width card, but each field stays at its min width rather than stretching across it.
		'& > div': {
			flex: '0 1 auto',
			minWidth: 370,
			'& .MuiFilledInput-root, & .MuiTextField-root': { minWidth: 370 }
		}
	}
}))

const FriendsOfSkiptownSectionFields = ({ facility, facilityId }) => {
	const classes = useStyles()
	const dispatch = useDispatch()

	const section = facility?.friends_of_skiptown || {}
	const savedTitle = section.title || ''
	const savedSubtitle = section.subtitle || ''

	const [title, setTitle] = useState(savedTitle)
	const [subtitle, setSubtitle] = useState(savedSubtitle)
	const [saving, setSaving] = useState(false)
	// The app hides the whole section unless this is exactly true.
	const shown = facility?.show_friends_of_skiptown === true

	// Reseed from the store whenever the saved values change — after a save, or when the
	// selected facility switches out from under us.
	useEffect(() => {
		setTitle(savedTitle)
		setSubtitle(savedSubtitle)
	}, [facilityId, savedTitle, savedSubtitle])

	const dirty = title !== savedTitle || subtitle !== savedSubtitle

	const save = async () => {
		setSaving(true)
		await dispatch(updateFriendsOfSkiptownSection(facilityId, { title, subtitle }))
		setSaving(false)
	}

	// Saves straight away, independently of the heading fields.
	const toggleShown = async () => {
		setSaving(true)
		await dispatch(updateFriendsOfSkiptownSection(facilityId, { show_friends_of_skiptown: !shown }))
		setSaving(false)
	}

	return (
		<Card className={classes.root}>
			<CardHeader
				title="Section Heading"
				action={
					<Box className={classes.showToggle}>
						<Typography variant="body2">Show in app</Typography>
						<StyledSwitch checked={shown} onChecked={toggleShown} disabled={saving} />
					</Box>
				}
			/>
			<CardContent>
				<div className={classes.fields}>
					<div>
						<StyledTextField
							label="Title"
							variant="filled"
							fullWidth
							placeholder={TITLE_FALLBACK}
							value={title}
							disabled={saving}
							onChange={(e) => setTitle(e.target.value)}
						/>
					</div>
					<div>
						<StyledTextField
							label="Subtitle"
							variant="filled"
							fullWidth
							placeholder={SUBTITLE_FALLBACK}
							value={subtitle}
							disabled={saving}
							onChange={(e) => setSubtitle(e.target.value)}
						/>
					</div>
				</div>
				<Button variant="contained" color="secondary" onClick={save} disabled={saving || !dirty}>
					{saving ? 'Saving…' : 'Save'}
				</Button>
			</CardContent>
		</Card>
	)
}

export default FriendsOfSkiptownSectionFields
